import { render, staticRenderFns } from "./singleStar.vue?vue&type=template&id=2d9cd3d2&scoped=true&lang=html&"
import script from "./singleStar.vue?vue&type=script&lang=js&"
export * from "./singleStar.vue?vue&type=script&lang=js&"
import style0 from "./singleStar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./singleStar.vue?vue&type=style&index=1&id=2d9cd3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9cd3d2",
  null
  
)

export default component.exports